var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWeight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 22.75H10C4.57 22.75 2.25 20.43 2.25 15V9C2.25 3.57 4.57 1.25 10 1.25H14C19.43 1.25 21.75 3.57 21.75 9V15C21.75 20.43 19.43 22.75 14 22.75ZM10 2.75C5.39 2.75 3.75 4.39 3.75 9V15C3.75 19.61 5.39 21.25 10 21.25H14C18.61 21.25 20.25 19.61 20.25 15V9C20.25 4.39 18.61 2.75 14 2.75H10Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0696 12.54C14.8896 12.54 14.7096 12.47 14.5696 12.35C13.1096 11.05 10.8896 11.05 9.42963 12.35C9.26963 12.5 9.04962 12.56 8.81962 12.53C8.59962 12.5 8.40962 12.37 8.28962 12.18L6.10963 8.67998C5.91963 8.36998 5.97962 7.96998 6.24962 7.71998C9.52962 4.80998 14.4696 4.80998 17.7496 7.71998C18.0196 7.95998 18.0796 8.36998 17.8896 8.67998L15.7096 12.18C15.5896 12.37 15.3996 12.49 15.1796 12.53C15.1396 12.53 15.0996 12.54 15.0696 12.54ZM11.9996 9.86998C12.9996 9.86998 13.9896 10.15 14.8596 10.7L16.2596 8.44998C13.7296 6.56998 10.2596 6.56998 7.72962 8.44998L9.12963 10.7C10.0096 10.14 10.9996 9.86998 11.9996 9.86998Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeight);
export default __webpack_public_path__ + "static/media/weight.9fc26e46beb9e1f86b994790f6bf7aa8.svg";
export { ForwardRef as ReactComponent };